import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function GoogleCallback() {
  const { completeGoogleLogin } = useAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const code = params.get("code");
    const errParam = params.get("error");
    if (errParam) {
      setError("Google sign-in was cancelled or failed.");
      return;
    }
    if (!code) {
      setError("Missing authorization code.");
      return;
    }
    completeGoogleLogin(code)
      .then(() => navigate("/dashboard", { replace: true }))
      .catch(() => setError("We couldn't complete Google sign-in. Please try again."));
  }, [params, completeGoogleLogin, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center px-6">
      <div className="text-center">
        {error ? (
          <>
            <p className="font-display text-2xl text-foreground">Sign-in issue</p>
            <p className="mt-2 text-sm text-muted-foreground">{error}</p>
            <button onClick={() => navigate("/login")} className="mt-6 rounded-xl bg-primary px-5 py-2.5 text-sm text-primary-foreground">Back to sign in</button>
          </>
        ) : (
          <>
            <div className="mx-auto h-8 w-8 animate-spin rounded-full border-2 border-border border-t-[hsl(var(--gold))]" />
            <p className="mt-4 text-sm text-muted-foreground">Completing sign-in…</p>
          </>
        )}
      </div>
    </div>
  );
}
